/**
 * Created by anatoly on 15.04.2026
 */

const FillHandCardTutorial = function () {
    return new TutorialScenario(FillHandCardTutorial.NAME, {
        listSteps: () => [
            FillHandCardTutorial.showFillHandStep()
        ],

        onStart: function () {
            Game.currentGame.shownTutorials.push(FillHandCardTutorial.NAME);
        },

        isAvailable: () => Game.currentGame
            && !Game.currentGame.shownTutorials.includes(FillHandCardTutorial.NAME)
            && cleverapps.user.checkAvailable(cleverapps.config.availables.FILL_HAND_TUTORIAL)
    });
};

FillHandCardTutorial.showFillHandStep = () => new TutorialStep({
    onStart: function () {
        const fillHandCards = Game.currentGame.table.cards
            .filter((card) => card instanceof FillHandCard)
            .map((card) => card.onGetView());

        this.force = cleverapps.forces.create(ForceView.NO_ELEMENT, {
            text: "FillHandCardTutorialMessage",
            closeByTouchInShadow: {
                delay: 3000
            }
        }, {
            highlights: fillHandCards,
            importantNodes: fillHandCards
        });

        cleverapps.tutorial.on("touchInShadow", this.finish.bind(this), this);
    },
    onFinish: function () {
        this.force.hideForceHints();
        Game.currentGame.counter.trigger();
    }
});

FillHandCardTutorial.NAME = "fillHand";
